import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import secureLocalStorage from "react-secure-storage";
import {
  setSelectedState,
  setSelectedCounty,
  setSelectedFips,
  setLandCoverSelections,
  setPrioritySelections,
  setRankingScore,
  setHydrated,
} from "../../Redux/filterSlice";
import {
  fetchGeoCountiesByState,
  fetchGeoStates,
} from "../../Redux/geo/geoThunk";
import { fetchAllPracticeDataByCounty } from "../../Redux/practice/practiceThunk";

const useHydrateFilterState = () => {
  const dispatch = useDispatch();
  const currentFilterState = useSelector((state) => state.filter);
  const hydrated = currentFilterState.hydrated;

  useEffect(() => {
    const savedFilterData = secureLocalStorage.getItem("filter-selections");

    if (savedFilterData) {
      const {
        selectedState,
        selectedCounty,
        selectedFips,
        landCoverSelections,
        prioritySelections,
        rankingScore,
      } = savedFilterData;

      if (selectedState && selectedState !== currentFilterState.selectedState)
        dispatch(setSelectedState(selectedState));

      if (
        selectedCounty &&
        selectedCounty !== currentFilterState.selectedCounty
      )
        dispatch(setSelectedCounty(selectedCounty));

      if (selectedFips && selectedFips !== currentFilterState.selectedFips)
        dispatch(setSelectedFips(String(selectedFips).padStart(5, "0")));

      if (
        Array.isArray(landCoverSelections) &&
        JSON.stringify(landCoverSelections) !==
          JSON.stringify(currentFilterState.landCoverSelections)
      )
        dispatch(setLandCoverSelections(landCoverSelections));

      if (
        Array.isArray(prioritySelections) &&
        JSON.stringify(prioritySelections) !==
          JSON.stringify(currentFilterState.prioritySelections)
      )
        dispatch(setPrioritySelections(prioritySelections));

      if (
        rankingScore &&
        JSON.stringify(rankingScore) !==
          JSON.stringify(currentFilterState.rankingScore)
      )
        dispatch(setRankingScore(rankingScore));
    }

    dispatch(setHydrated(true));
  }, [dispatch]);

  useEffect(() => {
    if (hydrated) {
      const { selectedState, selectedCounty } = currentFilterState;

      const hydrate = async () => {
        if (selectedState) {
          await dispatch(fetchGeoCountiesByState(selectedState)).unwrap(); // ✅ wait for counties
        }
        if (selectedState && selectedCounty) {
          await dispatch(fetchAllPracticeDataByCounty()); // ✅ fetch with counties loaded
        }
      };

      hydrate();
    }
  }, [hydrated, dispatch]);
};

export default useHydrateFilterState;
